"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var DepartmentResource = /** @class */ (function (_super) {
    tslib_1.__extends(DepartmentResource, _super);
    function DepartmentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DepartmentResource.endpoint = '/departments';
    DepartmentResource.MODEL_NAME = 'department';
    return DepartmentResource;
}(base_1.default));
exports.default = DepartmentResource;
//# sourceMappingURL=department.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/department.js
// module id = KfXd
// module chunks = 0